/* eslint-disable camelcase */
import PropTypes from 'prop-types'

import { eslLevels } from './levels'

const audiences = PropTypes.arrayOf(
  PropTypes.oneOf(['Young Learners', 'Teens', 'Adults'])
)

const cefrLevels = PropTypes.arrayOf(
  PropTypes.oneOf(['A0', 'A1', 'A2', 'B1', 'B2', 'C1', 'C2'])
)

const clblevels = PropTypes.arrayOf(
  PropTypes.oneOf([
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
  ])
)

const eldLevels = PropTypes.arrayOf(
  PropTypes.oneOf([
    'Pre ELD',
    'ELD 1',
    'ELD 2',
    'ELD 3',
    'ELD 4',
    'ELD 5',
    'ELD 6',
  ])
)

const levels = PropTypes.arrayOf(PropTypes.oneOf(eslLevels))

export const lessonPropShape = PropTypes.shape({
  audiences: audiences.isRequired,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  lesson_section_id: PropTypes.number.isRequired,
  lesson_section_title: PropTypes.string.isRequired,
  description: PropTypes.string,
  has_audio: PropTypes.bool,
  has_video: PropTypes.bool,
  id: PropTypes.number.isRequired,
  image_url: PropTypes.string.isRequired,
  is_featured: PropTypes.bool,
  is_resource: PropTypes.bool,
  levels,
  title: PropTypes.string.isRequired,
})

export const flashcardPropShape = PropTypes.shape({
  audiences,
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  genre: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  levels,
  id: PropTypes.number.isRequired,
  image_url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})

export const flashcardCategoryPropShape = PropTypes.shape({
  audiences,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  genre: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  levels,
  id: PropTypes.number.isRequired,
  image_url: PropTypes.string,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})

export const postPropShape = PropTypes.shape({
  audiences,
  author: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ).isRequired,
  category_titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  created_at: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  levels,
  id: PropTypes.number.isRequired,
  image_url: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
})

export const collectionPropShape = PropTypes.shape({
  audiences,
  id: PropTypes.number.isRequired,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  description: PropTypes.string,
  levels,
  list_category_id: PropTypes.number.isRequired,
  list_category_title: PropTypes.string.isRequired,
  list_category_slug: PropTypes.string.isRequired,
  list_category_image_url: PropTypes.string.isRequired,
  image_url: PropTypes.string, // some collection may not have an image_url but will always have a list_category_image_url
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tag: PropTypes.string,
})

export const videoPropShape = PropTypes.shape({
  audiences,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  description: PropTypes.string,
  levels,
  image_url: PropTypes.string, // some collection may not have an image_url but will always have a list_category_image_url
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  genre: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  tag_list: PropTypes.arrayOf([PropTypes.string]),
})

export const coursePropShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  levels,
  image_url: PropTypes.string,
  audiences,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  tag_list: PropTypes.arrayOf([PropTypes.string]),
})

export const studyPackPropShape = coursePropShape

export const pollPropShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  topic: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  description: PropTypes.string,
  image_url: PropTypes.string,
  audiences,
  levels,
  cefr_levels: cefrLevels,
  clb_levels: clblevels,
  eld_levels: eldLevels,
  tag_list: PropTypes.arrayOf([PropTypes.string]),
})
